import { html, View } from 'rune-ts';
import klass from './LimitedSaleSelectField.module.scss';
import { font } from '../../../../../shared/typography';
import { isNessApp } from '@modules/Util/S/Function/module';
import { ProductBadgeSize } from '@services/MarppleShop/features/ProductBadge';
import { ProductBadgeView } from '@services/MarppleShop/renderApp/components/cells/ProductBadge';
import { NessBadgeView } from '@modules/Ness/App/ProductBadge/components';

export class LimitedSaleSelectField extends View<{
  klass?: string;
}> {
  protected override template() {
    if (isNessApp()) {
      return html` <div class="${klass.LimitedSaleSelectField} ${this.data.klass || ''}">
        <span class="${klass.footer_text} ${font('13_regular')}">
          <span>한정 판매 종료일 또는 한정 판매 수량 설정 시</span>
          <span class="${klass.badge}">
            ${new NessBadgeView({
              type: 'Special_offer',
            })}
          </span>
          <span>으로 표시됩니다.</span>
        </span>
      </div>`;
    } else {
      return html` <div class="${klass.LimitedSaleSelectField} ${this.data.klass || ''}">
        <span class="${klass.footer_text} ${font('13_regular')}">
          <span>한정 판매 종료일 또는 한정 판매 수량 설정 시</span>
          ${new ProductBadgeView({
            type: 'Limited',
            options: {
              lang: ET.lang,
              size: ProductBadgeSize.small,
              klass: klass.badge,
              baseTimestamp: Date.now(),
            },
          })}
          <span>으로 표시됩니다.</span>
        </span>
      </div>`;
    }
  }
}
